import { render, staticRenderFns } from "./the-popups.vue?vue&type=template&id=c5a5af0e&"
import script from "./the-popups.vue?vue&type=script&lang=js&"
export * from "./the-popups.vue?vue&type=script&lang=js&"
import style0 from "./the-popups.vue?vue&type=style&index=0&id=c5a5af0e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports